<template>
	<div class="b-catalog__pagination">
		<el-select v-model="value" @change="onSelect">
			<el-option
				v-for="item in options"
				:key="item.value"
				:label="item.value"
				:value="item.value">
				{{item.label}}
			</el-option>
		</el-select>
	</div>
</template>

<script>
export default {
	name: "PaginationCount",
	props: {
		options: {
			type: [Array, Object],
			default: () => {
				return []
			}
		},
		selected: {
			type: [Number, String],
			default: ""
		}
	},
	data() {
		return {
			value: null
		}
	},
	computed: {
		current() {
			return this.getItem(this.value);
		}
	},
	created() {
		this.value = this.selected;
	},
	methods: {
		onSelect() {
			if (this.current) {
				BX.setCookie(
					this.current.cookieName,
					this.current.value,
					{path: "/"}
				);
				window.location.reload();
			}
		},
		getItem(value) {
			for (let i in this.options) {
				if (this.options[i].value == value) {
					return this.options[i];
				}
			}

			return null;
		},
	}
}
</script>